import { PaymentMethod } from "@app/models/PaymentMethod";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { UserStore } from "@app/services/stores/UserStore";
import { PaymentHistory } from "@app/models/PaymentHistory";
import { PaymentMethodApi } from "@app/services/apiServices/PaymentMethodApi";
import { take } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { Inject, Injectable } from "@angular/core";
import { formatInTimeZone } from "date-fns-tz";
import {
    ExpandedPaymentHistoryDetailDialog
} from "@app/components/expandedPaymentHistoryDetail/expandedPaymentHistoryDetail.dialog";
import { AppDate } from "@app/util/app-date";

/**
 * Created by req85103 on 6/14/17.
 */
@Injectable({ providedIn: "root" })
export class ExpandedPaymentHistoryDetailComponent {
    paymentMethodIds: number[]

    constructor(
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentMethodApi) private paymentMethodApi: PaymentMethodApi,
        @Inject(UserStore) private userStore: UserStore,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService
    ) { }

    loadExpandedPaymentHistoryDetail(paymentHistory: PaymentHistory) {

        this.paymentMethodIds = []
        let userId = this.userStore.getHoaHomeownerId();

        const createdDate = new Date(paymentHistory.createdDate);
        let dateTimestamp = formatInTimeZone(createdDate, AppDate.timezone, 'MM/dd/yy h:mm a zzz')

        this.paymentMethodApi.homeownersIdPaymentMethodsGet(userId)
            .pipe(take(1)).subscribe((resp) => {
                const paymentMethods: PaymentMethod[] = resp

                for (let i = 0; i < paymentMethods.length; i++) {
                    this.paymentMethodIds.push(paymentMethods[i].id)
                }

                paymentHistory.paymentDateWithTimestamp = dateTimestamp
                if (paymentHistory.paymentMethodId && this.paymentMethodIds.indexOf(paymentHistory.paymentMethodId) > -1) {
                    this.paymentMethodApi.paymentMethodsIdGet(paymentHistory.paymentMethodId.toString())
                        .pipe(take(1)).subscribe((resp) => {
                            paymentHistory.paymentMethod = resp;

                            this.dialog.open(ExpandedPaymentHistoryDetailDialog, {
                                data: {
                                    paymentHistory
                                }
                            })
                        }, (err) => {
                            console.error(err.error);
                        })
                } else {
                    this.dialog.open(ExpandedPaymentHistoryDetailDialog, {
                        data: {
                            paymentHistory
                        }
                    })
                }
            }, (err) => {
                this.networkErrorService.handleNetworkError(err, true)
                    .pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            this.loadExpandedPaymentHistoryDetail(paymentHistory);
                        }
                    });
            })
    }
}
